import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import AppConfigService from 'app/core/app-config.service';

@Injectable({ providedIn: 'root' })
export default class Register {
  constructor(private http: HttpClient, private router: Router) {}

  save(account: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/register`, account);
  }

  registerUser(account: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile`, account);
  }

  updateUser(account: any): Observable<any> {
    return this.http.put(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile`, account);
  }
}
